import MetricProfile from './MetricProfile'

export default MetricProfile
